/**
 * Inicialización central de Firebase del lado cliente.
 *
 * Incluye:
 * - app base,
 * - analytics,
 * - auth,
 * - Firestore,
 * - helpers para persistir y recuperar `subscriptionId`.
 *
 * Importante:
 * - Las claves aquí visibles son credenciales públicas de cliente Firebase.
 * - Aun así, conviene migrarlas a `REACT_APP_*` para mantener consistencia
 *   entre entornos y documentar mejor el despliegue.
 */
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore"; // Importar Firestore

// Configuración web pública de Firebase usada por la app cliente.
const firebaseConfig = {
  apiKey: "AIzaSyD8YQYEKu4eztidoFXO5AzOma65aUXWJqU",
  authDomain: "mentfull.firebaseapp.com",
  projectId: "mentfull",
  storageBucket: "mentfull.firebasestorage.app",
  messagingSenderId: "540594891547",
  appId: "1:540594891547:web:3bc76eae9e29e9bcce41be",
  measurementId: "G-4MB46EZRHC",
};
// Inicializamos Firebase
export const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
export const auth = getAuth(app);
export { createUserWithEmailAndPassword };

// Inicializamos Firestore
export const db = getFirestore(app);

// Persiste el id devuelto por PayPal para futuras validaciones o cancelaciones.
export const saveSubscriptionId = async (userUid, subscriptionId) => {
  try {
    const userRef = doc(db, "users", userUid);
    await updateDoc(userRef, {
      subscriptionId: subscriptionId,
    });
    console.log("ID de suscripción guardado exitosamente en Firestore.");
  } catch (error) {
    console.error("Error guardando el ID de suscripción:", error);
  }
};

// Recupera el subscriptionId desde la colección `users`.
export const getSubscriptionIdFromFirebase = async (userUid) => {
  console.log("checnado suscripción de usuario con id:", userUid);
  try {
    const userRef = doc(db, "users", userUid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      const data = userDoc.data();
      return data.subscriptionId || null;
    } else {
      console.error("No se encontró el usuario en Firestore.");
      return null;
    }
  } catch (error) {
    console.error("Error obteniendo el ID de suscripción:", error);
    return null;
  }
};
